import { createRoot } from "react-dom/client";
import Modal from "react-modal";
import { Provider as ReduxProvider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { cacheExchange, createClient, fetchExchange, Provider as URQLProvider } from "urql";
import { AlertProvider } from "../shared/components/Alerts";
import { ConfirmProvider } from "../shared/components/ConfirmDialogue";
import GenericErrorBoundary from "../shared/components/GenericErrorBoundary";
import sentryExchange from "../shared/sentryExchange";
import { CurrentPersonProvider } from "./components/CurrentPerson";
import { SelectedIdsProvider, selectedIdsExchange } from "./components/SelectedIds";
import { UnreadInspirationsProvider } from "./components/UnreadInspirations";
import { UnreadMessagesProvider } from "./components/UnreadMessages";
import Player from "./Player";
import { store } from "./state";

export const client = createClient({
    exchanges: [cacheExchange, sentryExchange, selectedIdsExchange, fetchExchange],
    fetchOptions: {
        credentials: "same-origin",
        headers: {
            "X-CSRFToken": __CSRF_TOKEN__,
        },
    },
    requestPolicy: "cache-and-network",
    url: "/graphql/player",
});

const router = createBrowserRouter([
    {
        path: "*",
        element: <Player />,
        errorElement: <GenericErrorBoundary />,
    },
]);

// init function
export default function init() {
    const container = document.getElementById("player-page");
    Modal.setAppElement(container);
    const root = createRoot(container);
    root.render(
        <URQLProvider value={client}>
            <ReduxProvider store={store}>
                <AlertProvider>
                    <SelectedIdsProvider>
                        <CurrentPersonProvider>
                            <UnreadMessagesProvider>
                                <UnreadInspirationsProvider>
                                    <ConfirmProvider>
                                        <RouterProvider router={router} />
                                    </ConfirmProvider>
                                </UnreadInspirationsProvider>
                            </UnreadMessagesProvider>
                        </CurrentPersonProvider>
                    </SelectedIdsProvider>
                </AlertProvider>
            </ReduxProvider>
        </URQLProvider>,
    );
}
